(() => {
  function init(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const visibleIds = new Set([...root.querySelectorAll('[data-tube-variant-id]')].map(t => t.dataset.tubeVariantId));
    const variants = JSON.parse(root.querySelector('[data-tube-variants]').textContent).filter(v => visibleIds.has(String(v.id)));
    const selectors = [...root.querySelectorAll('[data-tube-option]')];
    const section = root.closest('[data-section-type="product"], [data-section-type="featured-product"]');
    if (!section) return;
    let selectedVariant;
    function synchronize(firstRun = false) {
      const info = root.querySelector('[data-tube-info]');
      if (info) root.append(info);
      selectors.forEach((select, index) => {
        const candidates = variants.filter(v => selectors.slice(0, index).every((prior, position) => v.options[position] === prior.value));
        const values = [...new Set(candidates.map(v => v.options[index]))];
        const previous = select.value;
        select.replaceChildren(...values.map(value => new Option(value, value)));
        const preferred = values.includes(previous) ? previous : candidates.find(v => v.available)?.options[index] || values[0];
        select.value = preferred || '';
        select.disabled = !values.length;
      });
      selectedVariant = variants.find(v => selectors.every((select, index) => v.options[index] === select.value));
      section.querySelectorAll('.js-product-form [name="id"]').forEach(input => {
        input.value = selectedVariant ? String(selectedVariant.id) : '';
        input.disabled = !selectedVariant;
      });
      selectors.forEach((select, index) => {
        const field = select.closest('.winnertube-picker__field');
        const current = field.querySelector('[data-tube-current]');
        const menu = field.querySelector('[data-tube-menu]');
        function choiceAvailable(value) {
          return variants.some(v => v.available && v.options[index] === value && selectors.slice(0, index).every((prior, position) => v.options[position] === prior.value));
        }
        field.querySelector('summary').classList.toggle('is-sold-out', !choiceAvailable(select.value));
        function choiceContent(value) {
          const label = document.createElement('span');
          const matchingVariant = variants.find(v => v.options[index] === value);
          label.textContent = matchingVariant?.compare_at_price > matchingVariant?.price ? value.replace(/\s*\(\s*\d+(?:[.,]\d+)?\s*%[^)]*\)/g, '').trim() : value;
          label.className = 'tube-select__title';
          const nodes = [label];
          if (index === 0) {
            const matches = variants.filter(v => v.options[0] === value);
            const pricedVariant = matches.find(v => selectors.slice(1).every((s, i) => v.options[i + 1] === s.value)) || matches.find(v => v.available) || matches[0];
            const template = [...root.querySelectorAll('template[data-tube-variant-id]')].find(t => t.dataset.tubeVariantId === String(pricedVariant?.id));
            if (template) {
              const price = document.createElement('span');
              price.className = 'tube-select__price';
              const promotion = root.querySelector('[data-tube-promotion]');
              price.append(template.content.cloneNode(true));
              if (promotion) {
                const meta = document.createElement('span');
                meta.className = 'tube-select__meta';
                meta.append(promotion.content.cloneNode(true));
                price.prepend(meta);
              }
              nodes.push(price);
            }
          }
          return nodes;
        }
        current.replaceChildren(...choiceContent(select.value));
        menu.replaceChildren(...[...select.options].map(option => {
          const li = document.createElement('li');
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'cc-select__option tube-select__choice';
          button.classList.toggle('is-sold-out', !choiceAvailable(option.value));
          button.setAttribute('aria-pressed', String(option.value === select.value));
          button.append(...choiceContent(option.value));
          button.addEventListener('click', () => {
            select.value = option.value;
            field.querySelector('details').open = false;
            synchronize();
            field.querySelector('summary').focus();
          });
          li.append(button);
          return li;
        }));
      });
      if (info) {
        const contentsTemplate = [...root.querySelectorAll('[data-tube-contents-id]')].find(t => t.dataset.tubeContentsId === String(selectedVariant?.id));
        const contents = contentsTemplate?.content.textContent.trim() || '';
        info.hidden = !contents;
        info.classList.remove('is-open');
        info.querySelector('[data-tube-contents]').textContent = contents;
        info.querySelector('button').setAttribute('aria-label', contents);
        info.querySelector('button').setAttribute('aria-expanded', 'false');
        const title = root.querySelector('[data-tube-current] .tube-select__title');
        if (title && contents) {
          const text = title.textContent.trim();
          const boundary = text.lastIndexOf(' ');
          const tail = document.createElement('span');
          tail.className = 'variant-title-tail';
          tail.append(document.createTextNode(text.slice(boundary + 1) + ' '), info);
          title.replaceChildren(document.createTextNode(boundary < 0 ? '' : text.slice(0, boundary + 1)), tail);
        }
      }
      if (window.theme?.OptionManager && window.theme.jQuery) {
        window.theme.OptionManager.updateProductDetails(selectedVariant || false, window.theme.jQuery(section), firstRun);
      }
      const stockNotice = root.querySelector('[data-tube-stock-notice]');
      if (stockNotice) stockNotice.hidden = !selectedVariant || selectedVariant.available;
      section.querySelectorAll('.js-product-form button[name="add"]').forEach(button => {
        button.disabled = !selectedVariant?.available;
      });
    }
    selectors.forEach(select => select.addEventListener('change', () => synchronize()));
    const infoButton = root.querySelector('.tube-bundle-info__button');
    if (infoButton) infoButton.addEventListener('click', event => {
      event.preventDefault();
      event.stopPropagation();
      const open = infoButton.parentElement.classList.toggle('is-open');
      infoButton.setAttribute('aria-expanded', String(open));
    });
    root.addEventListener('keydown', event => {
      if (event.key === 'Escape') {
        root.querySelector('[data-tube-info]')?.classList.remove('is-open');
        infoButton?.setAttribute('aria-expanded', 'false');
        const details = event.target.closest('details');
        if (details) { details.open = false; details.querySelector('summary').focus(); }
      }
    });
    document.addEventListener('click', event => {
      const info = root.querySelector('[data-tube-info]');
      if (info && !info.contains(event.target)) { info.classList.remove('is-open'); infoButton.setAttribute('aria-expanded', 'false'); }
      root.querySelectorAll('details[open]').forEach(details => { if (!details.contains(event.target)) details.open = false; });
    });
    root.querySelectorAll('details').forEach(details => details.addEventListener('toggle', () => {
      if (details.open) root.querySelectorAll('details').forEach(other => { if (other !== details) other.open = false; });
    }));
    section.addEventListener('submit', event => {
      if (!event.target.matches('.js-product-form')) return;
      const variant = variants.find(v => selectors.every((select, index) => v.options[index] === select.value));
      if (!variant?.available) {
        event.preventDefault();
        event.stopImmediatePropagation();
        return;
      }
      event.target.querySelectorAll('[name="id"]').forEach(input => { input.value = String(variant.id); });
    }, true);
    synchronize(true);
  }
  function load(scope = document) { scope.querySelectorAll('[data-winnertube-picker]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => load());
  else load();
  document.addEventListener('shopify:section:load', event => load(event.target));
})();
